// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3HUgm","open":"open___1RYBT","descriptionBodyText":"descriptionBodyText___3lg7b"};